// hooks/useConfigurationSettings.js
import { useState } from 'react';
import { DEFAULT_SETTINGS } from '../constants/defaultSettings';

/**
 * Custom hook to manage configuration settings
 * Handles state, save, and reset logic
 */
export const useConfigurationSettings = () => {
  const [configs, setConfigs] = useState(DEFAULT_SETTINGS);
  const [saveStatus, setSaveStatus] = useState(null); // null | 'saving' | 'saved'

  const updateConfig = (key, value) => {
    setConfigs(prev => ({ ...prev, [key]: value }));
  };

  const updateMultipleConfigs = (updates) => {
    setConfigs(prev => ({ ...prev, ...updates }));
  };

  const handleSave = async () => {
    setSaveStatus('saving');
    
    try {
      // TODO: Replace with actual API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Example API call:
      // await axios.post('/api/configuration/settings', configs);
      
      setSaveStatus('saved');
      setTimeout(() => setSaveStatus(null), 3000);
    } catch (error) {
      console.error('Failed to save settings:', error);
      setSaveStatus(null);
      // TODO: Show error notification
    }
  };

  const handleReset = () => {
    if (window.confirm('Are you sure you want to reset all settings to defaults?')) {
      setConfigs(DEFAULT_SETTINGS);
      setSaveStatus(null);
    }
  };

  return {
    configs,
    saveStatus,
    updateConfig,
    updateMultipleConfigs,
    handleSave,
    handleReset
  };
};
